import React from 'react'
import { Global, css } from '@emotion/react'
import styled from '@emotion/styled'

export type InvoiceProps = {
  invoice: any
  invoiceSettings: any
  company: any
  customer: any
}

const A4 = styled.div`
  position: relative;
  width: 21cm;
  //height: 29.7cm;
  min-height: 29.7cm;
  min-width: 21cm;
  margin-left: auto;
  margin-right: auto;
  background: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  border-radius: 4px;
  z-index: 2;
  @media print {
    box-shadow: none;
    page-break-after: always;
  }
  @media print {
    thead {
      display: table-header-group;
    }

    thead tr td {
      //padding: 500px;
    }

    tfoot {
      display: table-footer-group;
    }
  }
`

const Invoice = styled.div`
  //display: flex;
  //flex-direction: column;
  width: 100%;
  //padding: 0.7in 0.55in 0.7in 0.55in;
  padding: 0.55in 0.55in 0.45in 0.55in;
  position: relative;
  display: flex;
  flex-direction: column;
  @media print {
    display: initial;
  }

}

//overflow: hidden;
`

const Base: React.FC<InvoiceProps> = ({
                                        // @ts-ignore
                                        children,
                                        invoice,
                                        invoiceSettings
                                      }) => {
  return (
    <React.Fragment>

      <A4>
        <Global
          styles={css`
            @page {
              size: A4 portrait;
              //margin-top: calc(6cm - 0.55in);
              @top-center {
              }
            }
            @media print {
              body {
                margin: 500px;
              }
            }
            @page :first {
              margin-top: 0;
            }
            @media print {
              * {
                overflow: visible !important;
              }
            }

            .container-table-wrapper {
              flex: 1 0 auto;
            }

            .container-table {
              margin-top: -0.55in;
              border-spacing: 0;
              z-index: -1;
              width: 100%;
            }

            @media print {
              .container-table-wrapper {
                padding-left: inherit;
                padding-right: inherit;
              }

              .container-table {
                margin-top: 0;
                width: 100%;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                padding-left: inherit;
                padding-right: inherit;
                background: white;
              }
            }

            .empty-header {
              height: calc(0.55in + ${invoiceSettings.logoHeight}px + ${
                invoiceSettings.logoMarginTop
              }rem + 0.4in)
            }

            @media print {
              .empty-footer {
                height: ${
                  invoiceSettings.companyInformationPosition === 'top' ? 2 : 4
                }cm;
              }
            }

            .content {
              padding-top: calc(6cm - 0.55in - ${
                invoiceSettings.logoHeight
              }px - ${invoiceSettings.logoMarginTop}rem - 0.4in)
            }

            html {
            }

            body {
              margin: 0px;
              padding: 0px;
              background: #fafbfc;
              font-size: ${invoiceSettings.fontSize || 9}pt;
              font-family: ${
                invoiceSettings.fontFamily ? `'${invoiceSettings.fontFamily}',` : ''
              } -apple-system,
              BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial,
              sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
              'Segoe UI Symbol';
              color: ${invoiceSettings.textColor || '#555555'};
              //font-family:  Helvetica, Arial, sans-serif;
              //font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
              // Roboto, Oxygen-Sans, Ubuntu, Cantarell,
              //"Helvetica Neue", sans-serif;
              -webkit-font-smoothing: antialiased;

            }

            p {
              font-weight: 300;
              margin-block-start: 0em;
              margin-block-end: 0.5em;
              line-height: 1.35;
              white-space: pre-line;
            }

            p:last-of-type {
              margin-block-end: 0em;
            }

            .label {
              font-weight: 600;
              margin-top: 0px;
              margin-bottom: 0.25em;
              color: black;
              letter-spacing: 0.03em;

              &.customer-name,
              &.company-name {
                margin-bottom: 0.1em;
              }
            }

            .logo {
              height: auto;
              max-width: 70%;
              margin-top: ${invoiceSettings.logoMarginTop}rem;
              text-align: ${
                invoiceSettings.logoPosition === 'left' ? 'left' : 'right'
              };

              img {
                height: ${invoiceSettings.logoHeight}px;
                width: 100%;
                object-fit: contain;
                object-position: ${
                  invoiceSettings.logoPosition === 'left' ? 'left' : 'right'
                };
              }

              .text-logo {
                margin: 0;
                padding: 0;
                white-space: pre-wrap;
                color: ${invoiceSettings.textLogoColor};
                letter-spacing: 0.02em;
                font-size: ${invoiceSettings.logoHeight}px;
                line-height: ${invoiceSettings.logoHeight}px;
              }
            }

            .company-information {
              text-align: ${
                invoiceSettings.logoPosition === 'left' ? 'right' : 'left'
              };
            }

            .company-information.bottom {
              text-align: left;
              display: flex;
              justify-content: space-between;
              margin-top: 2.5rem;
              margin-bottom: 0em;
              align-items: center;

              .label:not(.company-name) {
                width: 2.5rem;
                //color: inherit;
                display: inline-block;
                margin-bottom: 0;
                font-size: 0.8em;
                opacity: 0.9;
                text-transform: uppercase;
                letter-spacing: 0.05em;
              }

              .contact-information .label {
                width: 3rem;
              }
            }

            .customer {
              position: absolute;
              //padding-left: inherit;
              padding-left: 0.55in;
              left: ${invoiceSettings.customerPosition === 'left' ? 0 : 12.4}cm;
            }

            .invoice-information {
              margin-top: ${invoiceSettings.invoiceInformationMarginTop}rem;

              .title {
                font-size: 2em;
                font-weight: 500;
                letter-spacing: 0.03em;
                color: black;
                text-align: ${
                  invoiceSettings.customerPosition === 'left' ? 'right' : 'left'
                };
                margin: 0 0 0.8rem;
              }

              .invoice-information-content {
                display: flex;
                justify-content: space-between;
                flex-direction: ${
                  invoiceSettings.customerPosition === 'left'
                    ? 'row-reverse'
                    : 'column'
                };

                .invoice-details {
                  height: fit-content;
                  width: fit-content;
                  line-height: 1.8;
                  text-align: right;
                  background: #f9fafa;
                  padding: 0.8rem 1rem;
                  margin-bottom: 0.8rem;

                  &.horizontal {
                    //padding: 1rem 1.2rem;
                    padding: 1rem;

                    .invoice-details-content {
                      display: flex;
                      line-height: 1;
                      text-align: ${
                        invoiceSettings.customerPosition === 'left'
                          ? 'right'
                          : 'left'
                      };

                      > div:not(:last-of-type) {
                        padding-right: 3rem;
                      }

                      .label {
                        margin-bottom: 0;
                        margin-bottom: 0.35rem;
                      }
                    }
                  }

                  &.vertical .invoice-details-content {
                    .label {
                      text-align: left;
                      min-width: 8rem;
                    }
                  }
                }

                .description {
                  white-space: pre-wrap;
                  margin-top: ${invoiceSettings.descriptionMarginTop}rem;
                }
              }
            }

            .note {
              position: absolute;
              margin-top: ${invoiceSettings.noteMarginTop}rem;
              width: 48%;

              td p {
                text-align: left;
                margin-top: 0px;
                white-space: pre-wrap;
              }
            }

            .invoice-table {
              margin-top: 2.4rem;
              margin-bottom: 2.4rem;
              width: 100%;
              //table-layout: fixed;
              word-wrap: break-word;
              border-spacing: 0;

              th,
              td {
                line-height: 1.35;
                padding: 12px 8px;
                white-space: pre-line;
                //padding: 12px 16px;
                //padding: 12px 8px;
                /* padding: 8px 10px 8px 10px; */
              }

              td:first-of-type, th:last-of-type {
                padding-right: 16px;
              }

              td {
                //padding: 1rem;
              }

              td:last-of-type {
                white-space: nowrap;
              }

              thead tr {
                font-weight: 600;
                background: #f9fafa; //#F4F5F7
                color: black;
                letter-spacing: 0.03em;

                th {
                  font-weight: 600;
                  text-align: left;
                }

                th:nth-last-of-type(-n + 4) {
                  text-align: right;
                }
              }

              col.line-description {
                //width: 50%;
              }

              col.line-vat-percentage {
                width: 4.5rem;
              }

              col.line-amount, col.line-quantity, col.line-price {
                width: 6rem;
              }

              .invoice-line {
                padding: 0.7em 0;
                // td {border-bottom: 1px solid #d8d8d8;}
                &:last-of-type td {
                  // border-bottom: none;
                  //  border-bottom: 1px solid #DFE1E6;
                }

                td:nth-last-of-type(-n + 4) {
                  text-align: right;
                }
              }

              .invoice-totals {
                border-collapse: separate;
                text-align: right;

                ::before {
                  content: '';
                  display: block;
                  height: ${invoice.Lines.length > 2 ? 2 : 4.5}rem;
                }

                td {
                  line-height: 1;
                  white-space: nowrap;
                }

                tr {
                  &:first-of-type td div {
                    padding-top: 13px;
                  }

                  &:nth-last-of-type(2) td div {
                    padding-bottom: 12px;
                  }

                  &:nth-last-of-type(1) td div {
                    padding-top: 12px;
                    font-size: 1.2em;
                  }
                }

                tr {
                  &:first-of-type td:nth-last-of-type(3) {
                    border-top-left-radius: 0.3rem;
                  }

                  &:first-of-type td:last-of-type {
                    border-top-right-radius: 0.3rem;
                  }

                  &:last-of-type td:nth-last-of-type(3) {
                    border-bottom-left-radius: 0.3rem;
                  }

                  &:last-of-type td:last-of-type {
                    border-bottom-right-radius: 0.3rem;
                  }
                }

                td {
                  padding: 0px 0px;

                  div {
                    padding: 8px 8px;
                  }

                  &:nth-last-of-type(1) {
                    text-align: right;
                  }
                }

              }

              .total-amount {
                color: black;
                font-weight: 700;

                td:not(:first-of-type) div {
                  //border-top: 1px solid #dfe1e6;
                  border-top: 1px solid rgba(44, 53, 77, 0.12);
                }

              }

              .subtotal-amount {
                td div {
                  padding-top: 12px;
                }

                td:not(:first-of-type) div {
                  border-top: 1px solid rgba(44, 53, 77, 0.12);
                }
              }

              * {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
              }

              @media print {
                * {
                  -webkit-print-color-adjust: exact;
                  print-color-adjust: exact;
                }
              }
          `}
        />
        <Invoice>{children}</Invoice>
      </A4>
    </React.Fragment>
  )
}

export default Base
